export const style = `
::-webkit-scrollbar {
  width: 6px;
  height: 4px;
  background: #2e2e2e;
}

::-webkit-scrollbar-thumb {
  background: #a9a9a9;
  border-radius: 15px;
}

body {
  overflow-y: scroll !important;
  overflow-x: hidden;
  padding: 0 !important;
}

.baseButton {
  transition: color 0.3s, opacity 0.3s, background-color 0.3s, box-shadow 0.3s,
    background 0.3s;
  font-family: gilroy, sans-serif;
  color: Hsla(var(--template-button-color-main));
  border-radius: 4px;
  background-color: Hsla(var(--template-button-backgroundColor-main));
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  outline: 0;
  border: 0;
  margin: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  text-decoration: none;
  font-family: gilroy, helvetica, arial, sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  padding: 6px 16px;
  box-shadow: 0 3px 1px -2px RGB(0 0 0/20%), 0 2px 2px 0 RGB(0 0 0/14%),
    0 1px 5px 0 RGB(0 0 0/12%);
}
.baseButton_icon {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  padding: 0;
  box-shadow: none;
  border-radius: 50%;
}
.baseButton_icon,
.baseButton_icon:active,
.baseButton_icon:disabled,
.baseButton_icon:focus,
.baseButton_icon:hover {
  background-color: transparent;
}
.baseButton_base {
  padding: 0;
}


.style_icon__3U3ai {
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 1.5rem;
  transition: fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  flex-shrink: 0;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.style_link__3nfqH {
  text-decoration: none;
  color: inherit;
}
.style_link__QJbFy {
  display: block;
}




.style_dotsWrapper__3fj3f {
  display: flex;
  position: relative;
  justify-content: space-between;
}
.style_dot__khpNe {
  background: rgba(216, 230, 250, 0.3);
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.style_dot__khpNe.style_secondary__2QH2e {
  width: 8px;
  height: 8px;
  background: rgba(10, 13, 23, 0.3);
}

.blueDot {
  background: #34e7ff !important;
}

.style_select__17egz {
  background-color: hsla(0, 0%, 50.2%, 0.5);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  max-height: 60px;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
}

.style_arrow__2GnIA {
  background-color: transparent;
  height: 20px;
}
.style_arrow__2GnIA > svg {
  width: 20px;
  height: 20px;
  transition: transform 0.2s;
}
.style_title__f6zsl {
  color: #fff;
  font-family: gilroy;
  font-weight: 700;
  font-size: 25px;
}

.style_root__3psce {
  margin: 0;
}
.style_body1__2VhxG {
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}
.style_body1__2VhxG,
.style_body2__1qogZ {
  color: Hsla(var(--secondary-main));
  font-family: gilroy;
  font-weight: 400;
  text-transform: "";
}
.style_nav__1pC2U,
.style_root__1JNpQ {
  display: flex;
  align-items: center;
}
.style_root__1JNpQ {
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
  list-style: none;
  font-size: 1rem;
  font-family: gilroy;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  color: rgba(0, 0, 0, 0.54);
}
.style_root__15hSE {
  background: hsla(0, 0%, 100%, 0.1);
  border-radius: 20px;
  padding: 2px;
  height: 40px;
  width: 240px;
  display: flex;
  margin: 0;
}
.style_border__2I8O1 {
  border: 2px solid #4835ea;
}

.style_button__2CVkw {
  border-radius: 20px;
  min-width: 50%;
  width: 100%;
  height: 100%;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  font-family: gilroy;
  text-transform: uppercase;
  background: 0 0 !important;
  box-shadow: none;
}
.style_active__12RA_ {
  background: #4835ea !important;
}

.style_root__2cQpc {
  background: 0 0;
  border: none;
  position: relative;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  color: Hsla(var(--secondary-main));
}
.style_item__2SPtD {
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.4s;
}
.style_disable__2cdvM {
  transform: translateY(-200%);
}
.style_icon__2oyto {
  fill: currentColor;
}
.style_select__15g0B {
  height: 40px;
  border-radius: 4px;
  padding-right: 6px;
  padding-left: 11px;
  background-color: Hsla(var(--template-footer-select-background));
}
.style_select__15g0B,
.style_selectLabel__549uQ > span {
  font-family: gilroy, sans-serif;
  font-weight: 700;
  color: Hsla(var(--template-footer-select-color));
}
.style_selectLabel__549uQ > span {
  width: 80px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
}
.style_selectIcon__17e-U {
  transform: scale(0.5);
}
.style_selectIcon__17e-U polyline {
  stroke: Hsla(var(--template-footer-select-color));
}


.style_flexRow__2_xcw {
  flex-direction: row;
}
.style_breadcrumbs__301ba,
.style_flexRow__2_xcw {
  display: flex;
  align-items: center;
}
.style_breadcrumbs__301ba li a {
  text-decoration: none;
  color: Hsla(var(--template-footer-colorTransparent));
}
.style_breadcrumbs__301ba li:nth-child(2n) {
  margin: 0 16px;
  color: Hsla(var(--template-footer-colorTransparent));
}

.style_aboutBlock__3s9DS {
  padding-bottom: 32px;
}
.style_aboutBlock__3s9DS a {
  text-decoration: none;
  color: Hsla(var(--template-footer-colorSemiTransparent));
  font-weight: 700;
  font-family: gilroy, sans-serif;
  font-size: 16px;
}
.style_aboutBlock__3s9DS a:not(:first-child) {
  margin-left: 32px;
}
.style_termsBlock__29pQg {
  display: flex;
  flex-wrap: wrap;
}
.style_termsElements__2DMQi {
  margin-top: 20px;
}
.style_description__1QH5k {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.style_social__1Flma {
  min-width: 116px;
  display: flex;
  align-items: center;
  margin-left: 36px;
  margin-right: 56px;
}
.style_socialIcon__2-g8L {
  padding: 0;
  height: 32px;
  width: 32px;
  background: 0 0;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_socialIcon__2-g8L:not(:first-child) {
  margin-left: 10px;
}
.style_socialIcon__2-g8L img {
  width: 100%;
  height: 100%;
}
.style_select__3SAjc {
  width: 115px;
}
.style_link__3id41 {
  text-decoration: none;
  color: Hsla(var(--template-footer-colorTransparent));
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
.style_themeChange__2zsF2 {
  margin-right: 10px;
}

.style_logo__vidHl path {
  fill: Hsla(var(--template-footer-logos-pasino-background));
  opacity: Hsla(var(--template-footer-logos-pasino-opacity));
}
.style_copyright__23wuY {
  padding-top: 20px;
}

.style_description__36OY2 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.style_footer__2BZpI {
  display: flex;
  justify-content: center;
  overflow: hidden;
  color: Hsla(var(--template-footer-colorTransparent));
  font-size: 12px;
  line-height: 20px;
  flex-wrap: wrap;
}
.style_container__7a2rS {
  display: flex;
  flex-wrap: wrap;
}
.style_container__7a2rS > div {
  padding: 7px;
}

html {
  font-display: optional;
}
body,
html {
  height: 100%;
}
body {
  margin: 0;
  background-color: #301b52;
}

.style_text__uUDxw {
  margin: 0;
  font-size: 0.65rem;
  color: #fff;
  overflow-wrap: anywhere;
  font-weight: 700;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.172339);
  font-family: gilroy;
}
.style_textMin__2uXiJ {
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.88px;
}
.style_textBig__enlQr {
  font-size: 14.7px;
  line-height: 18px;
  letter-spacing: 1.176px;
}

.style_appBar__2jgdr {
  position: fixed;
  top: 0;
  min-height: 50px;
  z-index: 1201;
  box-shadow: none;
  overflow: hidden;
  background-color: Hsla(var(--template-appBar-backgroundColor));
  transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1),
    margin 195ms cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-direction: column;
  color: #fff;
}
@media (min-width: 600px) {
  .style_appBar__2jgdr {
    min-height: 64px;
  }
}
.style_toolbar__20C0Z {
  display: flex;
  position: relative;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  min-height: 56px;
}
@media (min-width: 600px) {
  .style_toolbar__20C0Z {
    padding-left: 24px;
    padding-right: 24px;
    min-height: 64px;
  }
}
@media (min-width: 0px) and (orientation: landscape) {
  .style_toolbar__20C0Z {
    min-height: 48px;
  }
}
.style_grow__1sckx {
  flex: 1 1 auto;
}
.style_menuButton__1F5oa {
  margin-left: -12px;
}
.style_menuButton__1F5oa svg {
  min-width: 32px;
  min-height: 32px;
}

.style_banner__1Fsaj {
  display: none;
}
@media (min-width: 960px) {
  .style_banner__1Fsaj {
    display: block;
  }
}

.style_pasinoLogo__qoN3T {
  height: 46px;
  width: 135px;
  margin: 0 28px;
  display: block;
}
.style_pasinoLogo__qoN3T path {
  fill: Hsla(var(--template-appBar-menu-fill));
}
@media (max-width: 445px) {
  .style_pasinoLogo__qoN3T {
    display: none;
  }
}
.style_background__QoUbu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background: Hsla(var(--template-page-background));
}
@media (max-width: 340px) {
  .style_walletIcon__28QmW {
    margin-left: -12px;
  }
}

.style_loginBtn__1iJ8U {
  border: 0.965px solid #4835ea;
}
@media (max-width: 600px) {
  .style_loginBtn__1iJ8U {
    font-weight: 700;
    font-size: 10.2933px;
    line-height: 12px;
  }
}
@media (max-width: 1080px) {
  .style_feyorra__QyM5u {
    display: none;
  }
}

.style_wrapper__3F1Zg {
  margin-top: 64px;

}

.style_gridWrapper__1q4fX {
  padding: 16px;
}
@media (max-width: 600px) {
  .style_gridWrapper__1q4fX {
    padding: 0;
  }
}

.style_gridContentWrapper__10iEX {
  padding: 16px;
}

@media (max-width: 420px) {
  .style_gridContentWrapper__10iEX {
    padding: 0;
  }
}

:root {
  --primary-main: 262.90909deg, 50.45872%, 21.37255%;
  --primary-light: 263.18182deg, 23.40426%, 36.86275%;
  --primary-dark: 263.07692deg, 52%, 14.70588%;
  --primary-contrastText: 0deg, 0%, 100%;
  --primary-contrastIcon: 0deg, 0%, 100%;
  --secondary-main: 256.1194deg, 41.61491%, 68.43137%;
  --secondary-light: 261.36585deg, 82.99595%, 48.43137%;
  --secondary-dark: 256.59574deg, 19.34156%, 47.64706%;
  --secondary-contrastText: 0deg, 0%, 0%, 0.87059;
  --info-main: 262.10526deg, 88.37209%, 16.86275%;
  --info-light: 185.64706deg, 100%, 50%;
  --info-dark: 257.36842deg, 65.51724%, 11.37255%;
  --info-dark-2: 0deg, 0%, 0%, 0.5;
  --info-contrastText: 0deg, 0%, 100%;
  --subsidiary-red: 336.52174deg, 66.99029%, 59.60784%;
  --subsidiary-highlight: 261.36585deg, 82.99595%, 48.43137%;
  --subsidiary-blue: 186.11765deg, 100%, 50%, 0.8;
  --subsidiary-green: 92.21053deg, 74.80315%, 75.09804%;
  --onboarding-background: 262.58824deg, 87.62887%, 19.01961%;
  --onboarding-gradient-backgroundImage: url(/static/media/onboarding-gradient.d32485a8.svg);
  --template-header-background: 262.10526deg, 88.37209%, 16.86275%;
  --template-header-color: 261.36585deg, 82.99595%, 48.43137%;
  --template-box-background: 185.64706deg, 100%, 50%;
  --template-box-color: 185.64706deg, 100%, 50%;
  --template-button-color-main: 262.90909deg, 50.45872%, 21.37255%;
  --template-button-color-second: 262.90909deg, 50.45872%, 21.37255%;
  --template-button-color-transparent: 256.1194deg, 41.61491%, 68.43137%,
    0.74902;
  --template-button-backgroundColor-main: 256.1194deg, 41.61491%, 68.43137%;
  --template-button-backgroundColor-transparent: 256.1194deg, 41.61491%,
    68.43137%, 0.2;
  --template-button-backgroundColor-hover-main: 255.7377deg, 40.9396%, 70.78431%;
  --template-button-backgroundColor-hover-transparent: 255.7377deg, 40.9396%,
    70.78431%, 0.2;
  --template-button-backgroundColor-focus-main: 255.7377deg, 40.9396%, 70.78431%;
  --template-button-backgroundColor-focus-transparent: 255.7377deg, 40.9396%,
    70.78431%, 0.2;
  --template-button-backgroundColor-active-main: 255.7377deg, 40.9396%,
    70.78431%;
  --template-button-backgroundColor-active-transparent: 256.27119deg, 41.25874%,
    71.96078%, 0.2;
  --template-button-backgroundColor-disabled-main: 256.1194deg, 41.61491%,
    68.43137%, 0.50196;
  --template-button-backgroundColor-disabled-transparent: 256.1194deg, 41.61491%,
    68.43137%, 0.10196;
  --template-button-option-color: 246.66667deg, 20.93023%, 16.86275%;
  --template-input-label-color: 256.1194deg, 41.61491%, 68.43137%, 0.74902;
  --template-input-topLabel-color: 262.90909deg, 50.45872%, 21.37255%, 0.6;
  --template-input-text-color: 262.90909deg, 50.45872%, 21.37255%, 0.8;
  --template-page-joinBox-background: 257.14286deg, 67.36402%, 53.13725%;
  --template-page-joinBox-text: 94.10526deg, 70.37037%, 73.52941%;
  --template-bottomNavigation-background: 257.36842deg, 65.51724%, 11.37255%;
  --template-appBar-select-color: 262.90909deg, 50.45872%, 21.37255%, 0.74902;
  --template-appBar-menu-fill: 187.0936deg, 100%, 60.19608%;
  --template-appBar-icons-wallet-background: 261.42857deg, 100%, 78.03922%;
  --template-appBar-backgroundColor: 262.90909deg, 50.45872%, 21.37255%;
  --template-appBar-icons-help-background: 261.42857deg, 100%, 78.03922%;
  --template-appBar-icons-user-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-background: 262.90909deg, 50.45872%, 21.37255%;
  --template-footer-colorTransparent: 256.1194deg, 41.61491%, 68.43137%, 0.50196;
  --template-footer-colorSemiTransparent: 256.1194deg, 41.61491%, 68.43137%,
    0.74902;
  --template-footer-select-background: 256.1194deg, 41.61491%, 68.43137%;
  --template-footer-select-color: 262.90909deg, 50.45872%, 21.37255%;
  --template-footer-select-arrowIcon-color: 262.90909deg, 50.45872%, 21.37255%;
  --template-footer-select-menuItem-color: 261.36585deg, 82.99595%, 48.43137%;
  --template-footer-mobile-divider: 256.1194deg, 41.61491%, 68.43137%, 0.21176;
  --template-footer-mobile-color: 256.1194deg, 41.61491%, 68.43137%, 0.74902;
  --template-footer-logos-pasino-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-logos-bottomNavigation-background: 261.42857deg, 100%,
    78.03922%;
  --template-footer-logos-mga-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-logos-mga-innerBackground: 240deg, 83.87097%, 12.15686%;
  --template-footer-logos-plus18-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-icons-apple-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-icons-android-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-icons-twitter-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-icons-twitter-innerBackground: 240deg, 83.87097%, 12.15686%;
  --template-footer-icons-facebook-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-icons-facebook-innerBackground: 240deg, 83.87097%, 12.15686%;
  --template-footer-icons-discord-background: 261.42857deg, 100%, 78.03922%;
  --template-footer-icons-discord-innerBackground: 240deg, 83.87097%, 12.15686%;
  --template-anyContent-background: 263.07692deg, 52%, 14.70588%;
  --template-anyContent-colors-first: 256.1194deg, 41.61491%, 68.43137%;
  --template-anyContent-colors-second: 256.1194deg, 41.61491%, 68.43137%;
  --template-anyContent-colors-third: 240deg, 83.87097%, 12.15686%;
  --template-anyContent-colors-fourth: 256.1194deg, 41.61491%, 68.43137%;
  --template-anyContent-colors-five: 262.90909deg, 50.45872%, 21.37255%;
  --template-gameBlock-background: 256.1194deg, 41.61491%, 68.43137%;
  --template-gameCell-background: 0deg, 0%, 100%;
  --template-gameCell-wrapper: 257.36842deg, 65.51724%, 11.37255%;
  --template-gameCell-controller: 261.36585deg, 82.99595%, 48.43137%, 0.8;
  --template-gameCell-select-color: 257.36842deg, 65.51724%, 11.37255%, 0.50196;
  --template-gameCell-select-background: 257.36842deg, 65.51724%, 11.37255%,
    0.10196;
  --template-gameCell-select-currencyTitleColor: 257.36842deg, 65.51724%,
    11.37255%, 0.6;
  --template-gameCell-switch-activeColor: 185.64706deg, 100%, 50%;
  --template-gameCell-switch-noActiveColor: 185.64706deg, 100%, 50%;
  --template-gameCell-switch-activeBackground: 0deg, 0%, 100%;
  --template-gameCell-switch-noActiveBackground: 0deg, 0%, 100%;
  --template-gameCell-switch-text: 0deg, 0%, 100%;
  --template-gameCell-switch-selectedText: 0deg, 0%, 100%;
  --template-gameCell-gameButtons-dice: 262.90909deg, 50.45872%, 21.37255%;
  --template-gameCell-gameButtons-crash: 262.90909deg, 50.45872%, 21.37255%;
  --template-gameCell-gameButtons-plinko: 262.90909deg, 50.45872%, 21.37255%;
  --template-statisticsBlock-background: 0deg, 0%, 100%, 0.07059;
  --template-statisticsBlock-mobile-background: 0deg, 0%, 100%, 0.21176;
  --template-statisticsBlock-tabButton-color: 256.1194deg, 41.61491%, 68.43137%;
  --template-statisticsBlock-tab-color: 0deg, 0%, 100%;
  --template-statisticsBlock-tab-placeBackground: 0deg, 0%, 100%, 0.07059;
  --template-statisticsBlock-tab-avatarBackground: 256.1194deg, 41.61491%,
    68.43137%;
  --template-statisticsBlock-tab-tableHead: 0deg, 0%, 100%, 0.25098;
  --template-statisticsBlock-tab-tableBody: 0deg, 0%, 100%, 0.65098;
  --template-statisticsBlock-tab-mobile-tableBody: 256.1194deg, 41.61491%,
    68.43137%, 0.74902;
  --template-chat-massage-author-color: 256.1194deg, 41.61491%, 68.43137%;
  --template-chat-massage-moderator-color: 29.04977deg, 92.46862%, 53.13725%;
  --template-chat-massage-rating-fill: 0deg, 0%, 100%, 0.2;
  --template-chat-massage-rating-full: 36.70588deg, 100%, 50%;
  --template-chat-massage-textBlock-color: 256.1194deg, 41.61491%, 68.43137%;
  --template-chat-massage-textBlock-background: 256.1194deg, 41.61491%,
    68.43137%, 0.0902;
  --template-chat-massage-contactBlock-color: 262.5deg, 100%, 10.98039%;
  --template-chat-massage-contactBlock-background: 260.5deg, 74.07407%,
    68.23529%;
  --template-chat-massage-input-fill: 262.90909deg, 50.45872%, 21.37255%;
  --template-modal-title-color: 0deg, 0%, 100%;
  --template-modal-title-background: 246.95652deg, 37.2973%, 36.27451%;
  --template-modal-closeIcon-color: 0deg, 0%, 100%;
  --template-liveStats-header-background: 262.90909deg, 50.45872%, 21.37255%;
  --template-liveStats-header-title: 0deg, 0%, 100%;
  --template-liveStats-body-background: 257.36842deg, 65.51724%, 11.37255%;
  --template-liveStats-body-refresh: 0deg, 0%, 100%;
  --template-liveStats-body-color: 256.1194deg, 41.61491%, 68.43137%;
  --template-liveStats-time-arc-color: 153.96226deg, 62.35294%, 50%;
  --template-liveStats-bets-section-background: 262.10526deg, 88.37209%,
    16.86275%;
  --template-liveStats-bets-section-win: 153.96226deg, 62.35294%, 50%;
  --template-liveStats-bets-section-lose: 336.52174deg, 66.99029%, 59.60784%;
  --template-slot-gradient-start: 262.90909deg, 50.45872%, 21.37255%;
  --template-slot-gradient-end: 256.1194deg, 63.80952%, 20.58824%, 0;
  --template-page-backgroundColor: 262.90909deg, 50.45872%, 21.37255%;
  --decorations-christmas: 261.36585deg, 82.99595%, 48.43137%;
  --template-gameCell-shadow: 50px -20px 65px 9px rgba(0, 0, 0, 0.3);
  --template-appBar-background: #301b52;
  --template-page-background: #301b52;
  --template-footer-logos-bottomNavigation-opacity: 0.75;
  --template-footer-icons-android-opacity: 0.75;
  --template-appBar-icons-wallet-opacity: 0.75;
  --template-footer-logos-pasino-opacity: 0.75;
  --template-footer-logos-plus18-opacity: 0.5;
  --template-footer-icons-apple-opacity: 0.75;
  --template-footer-icons-facebook-opacity: 1;
  --template-appBar-icons-help-opacity: 0.75;
  --template-appBar-icons-user-opacity: 0.75;
  --template-footer-icons-twitter-opacity: 1;
  --template-footer-icons-discord-opacity: 1;
  --template-footer-logos-mga-opacity: 1;
}


html {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
*,
:after,
:before {
  box-sizing: inherit;
}

body {
  color: Hsla(var(--template-footer-logos-pasino-background), 0.75);
  margin: 0;
  font-size: 0.875rem;
  font-family: gilroy;
  font-weight: 500;
  line-height: 1.43;
  background-color: Hsla(var(--primary-main));
}
@media print {
  body {
    background-color: #fff;
  }
}


.style_banner__DswOE {
  position: relative;
  padding: 0 !important;
  margin: 0 8px !important;
  background: 0 0;
}

.style_bannerTextWrapper__3UeL_ {
  flip: false;
  position: absolute;
  top: 0;
  left: 0;
  width: 90px;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 5px;
}
.style_image__Q7ypI {
  background-size: 100%;
}

.style_item__10nqd {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: Hsla(var(--info-dark));
  border-radius: 10px;
  padding: 13px 25px 15px;
  width: 100%;
  min-width: -webkit-min-content;
  min-width: -moz-min-content;
  min-width: min-content;
  max-width: 256px;

}

.style_text__294tG {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: Hsla(var(--template-modal-title-color));
  white-space: nowrap;
}
@media (max-width: 600px) {
  .style_text__294tG {
    font-size: 11px;
    line-height: 14px;
  }
}
.style_icon__Z0epe {
  width: 31px;
  height: 31px;
  margin-right: 9px;
}
@media (max-width: 600px) {
  .style_icon__Z0epe {
    margin-right: 6.4px;
  }
}
.style_container__2yc3r {
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
 
}

.style_inner__3Rkvg {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 9px;
  margin: 30px auto 20px;
  height: 100%;
}
.style_container__3z7Aa {
  position: relative;
  display: flex;
  align-items: center;
  background: Hsla(var(--info-dark));
  padding-left: 10px;
  padding-right: 10px;
  height: 40px;
  border-radius: 10px 10px 0 0;
  width: fit-content;
}
.style_container__3z7Aa.style_left__VwMtZ {
  padding-left: 5px;
}
.style_container__3z7Aa.style_left__VwMtZ:before {
  left: -9%;
  -webkit-clip-path: polygon(100% 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(100% 0, 100% 0, 100% 100%, 0 100%);
}
.style_container__3z7Aa.style_left__VwMtZ:before,
.style_container__3z7Aa.style_right__3RA5B:after {
  position: absolute;
  top: 20%;
  content: "";
  display: block;
  width: 10%;
  height: 80%;
  background: Hsla(var(--info-dark));
}
.style_container__3z7Aa.style_right__3RA5B:after {
  left: 100%;
  -webkit-clip-path: polygon(0 0, 0 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 0 0, 100% 100%, 0 100%);
}
.style_title__pRWV9 {
  font-style: italic;
  font-weight: 900;
  font-size: 20px;
  color: Hsla(var(--template-modal-title-color));
  text-transform: capitalize;
  letter-spacing: 0.3px;
}
@media (max-width: 360px) {
  .style_title__pRWV9 {
    font-size: 16px;
  }
}

.style_listRoot__1nrDo {
  padding: 10px 8px;
  gap: 10px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.style_flex__3Bc5X {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.style_rootBanner__TMHjC {
  border-radius: 30px;
  overflow: hidden;
  background: 0 0 !important;
  transition: transform 0.5s;
}
.style_rootBanner__TMHjC:hover {
  transform: scale(1.05);
}
.style_label__NYUUG {
  padding: 0;
  margin: 0;
  font-family: gilroy;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: Hsla(var(--template-modal-title-color));
  width: 124px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
}
@media (max-width: 400px) {
  .style_label__NYUUG {
    width: 119px;
  }
}
.style_bannerImg__3YxyB,
.style_bannerRoot__RMafW {
  width: 164px;
  height: 164px;
  object-fit: cover;
}
@media (max-width: 400px) {
  .style_bannerImg__3YxyB,
  .style_bannerRoot__RMafW {
    width: calc(50vw - 15px);
    height: auto;
    max-width: 159px;
    max-height: 159px;
    padding: 0;
  }
}
.style_emptyBannerImg__11JbC {
  width: 164px;
  height: 164px;
}
@media (max-width: 400px) {
  .style_emptyBannerImg__11JbC {
    width: calc(50vw - 15px);
    max-width: 159px;
    height: 159px;
  }
}
.style_bigBanner__3srny,
.style_bigImg__3_MLE {
  width: 320px;
  height: 164px;
  padding: 0;
}
.style_bigBanner__3srny img,
.style_bigImg__3_MLE img {
  width: 320px;
}
@media (max-width: 400px) {
  .style_bigBanner__3srny,
  .style_bigImg__3_MLE {
    padding: 0;
    margin: 0 auto;
    min-width: 320px;
  }
}
.style_bigBannerLabel__1TgRc {
  width: calc(100% - 8px);
}
@media (max-width: 400px) {
  .style_bigBannerLabel__1TgRc {
    max-width: 320px;
  }
}
.style_continueContent__3MGZg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0 10px 10px;
  margin-bottom: 5px;
  width: calc(100% - 10px);
}
.style_link__3Cr7a {
  text-decoration: none;
}

.style_image___hBM6 {
  width: 100%;
  height: 100%;
  border-radius: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_logo__2ax5n {
  width: 133px !important;
}
.style_container__QouOA {
  background: Hsla(var(--info-dark));
  border-radius: 0 20px 20px 20px;
  margin-bottom: 30px;
}
.style_root__1ba7f {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background: hsla(0, 0%, 100%, 0.1);
  border-radius: 8px;
}

.style_wrapper__VKLCp {
  position: relative;
}
@media (max-width: 600px) {
  .style_wrapper__VKLCp {
    padding: 0 22px;
  }
}
.style_button__36W8h {
  background: #000 !important;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-shadow: none;
  padding: 0;
  opacity: 0.5;
  position: absolute;
  z-index: 1;
  top: calc(50% - 16px);
  left: 5px;
}
@media (max-width: 600px) {
  .style_button__36W8h {
    left: 27px;
  }
}
.style_button__right__1n9ox {
  left: auto;
  right: 5px;
}
@media (max-width: 600px) {
  .style_button__right__1n9ox {
    right: 27px;
  }
}
.style_dotsContainer__c7063 {
  position: absolute;
  bottom: 10px;
  left: 50%;
  margin: 10px;
  transform: translateX(-50%);
}









.style_wrapper__2Sncr {
  position: absolute;
  bottom: -28%;
  right: 0;
  width: 38%;
}
.banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}


.style_container__3W1Xy {
  margin: 2.5px;
  position: relative;
  height: 30vw;
  background: linear-gradient(
    84.48deg,
    #25013f 1.13%,
    indigo 27.68%,
    #9400d3 67%,
    #210038 99.17%
  );
  border-radius: 30px;
  overflow: hidden;  
}
@media (max-width: 600px) {
  .style_container__3W1Xy {
    border-radius: 10px;
  }
}
.style_bg__4WnA2 {
  width: 100%;
  height: 100%;
}

`;
